import { MemberBadge } from 'src/features/shared/components/MemberBadge'
import { Schemas } from '~/api/gen'
import { Img } from '~/components/elements/Img'
import fallbackIcon from '~/images/user_80.gif'

type Member = Pick<
  Schemas.member_small,
  | 'image'
  | 'user_name'
  | 'nick_name'
  | 'height'
  | 'is_wearista'
  | 'is_shop_clerk'
  | 'is_salon_clerk'
  | 'is_sponsored'
  | 'is_awarded'
>

type MemberInformationProps = {
  member: Member | null
  linkUrl?: string
  onAvatarClick?: () => void
  isFollowed?: boolean
}

export const MemberInformation: React.FC<MemberInformationProps> = ({
  member,
  linkUrl,
  onAvatarClick,
  isFollowed = false,
}) => {
  return (
    <div className="flex items-center gap-[7px]">
      <p className="size-8 shrink-0 overflow-hidden rounded-full border border-gray-300">
        {member && linkUrl ? (
          <a href={linkUrl} onClick={onAvatarClick}>
            {member.image.url_80 && (
              <Img
                src={member.image.url_80}
                width={32}
                height={32}
                alt={member.user_name}
              />
            )}
          </a>
        ) : (
          <Img src={fallbackIcon} width={32} height={32} alt="" />
        )}
      </p>
      {member !== null && (
        <div className="grow">
          <p className="flex items-center pt-1 leading-[1.2]">
            <span className="line-clamp-1 max-w-[58%] font-bold">
              {member.nick_name}
            </span>
            <MemberBadge
              member={member}
              className="ml-[7px] mt-[-1px] size-[15px]"
            />
            {member.height !== null && (
              <span className="pl-2">{member.height}cm</span>
            )}
          </p>
          {isFollowed && (
            <p className="pt-1 text-[10px] leading-normal text-gray-500">
              あなたをフォロー中
            </p>
          )}
        </div>
      )}
    </div>
  )
}
